
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap.xml",
      function () {
        return require("private-next-pages/sitemap.xml.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap.xml"])
      });
    }
  